import { getWindowLocationValues } from './helpers'

/**
 * Track form navigation events
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {string} event.direction
 * @param {string} event.fromStepId
 * @param {string} event.toStepId
 * @param {object} event.scope
 */
export function trackFormNavigationEvent(
  statsigClient,
  { direction, fromStepId, toStepId, scope },
) {
  statsigClient?.logEvent('form_navigation', `${fromStepId}_to_${toStepId}`, {
    direction,
    from_step_id: fromStepId,
    to_step_id: toStepId,
    form_id: scope?.form_id,
    form_entry_point: scope?.form_entry_point,
    ...getWindowLocationValues(scope),
  })
}
